/* Hero slide rotator — sections/home-hero.liquid.
 *
 * ES2019 only (FB/IG in-app WebViews) — no optional chaining / nullish
 * coalescing, and no `x != null ? x : y` either, because Shopify re-minifies
 * uploaded asset JS and rewrites that shape into `??`. See
 * scripts/validate-es2019.mjs.
 *
 * THE PASS IS BOUNDED, AND THAT IS THE FEATURE. Two slides means exactly ONE
 * transition per page view, and then it stops for good. It does not cycle back.
 * Removing the bound turns the hero into perpetual auto-updating content with
 * no way for a touch user to stop it, which is the WCAG 2.2.2 Level A failure
 * the bound exists to avoid. Read docs/adr/0002-the-top-bar-stops-on-its-own.md
 * before "fixing" the stop: the argument there is about the bar, but the
 * criterion is about this too.
 *
 * THE CAMPAIGN SLIDE IS THE ONE EVERYONE SEES. It is first in the DOM, already
 * opaque, and owns the only eager/high-priority image, so it is what paints and
 * what the LCP measures. A visitor who leaves within the hold sees the campaign
 * and nothing else — which is the right way round, and why the flip runs in
 * that direction rather than the other.
 *
 * NOTHING MOVES BEFORE LOAD. This waits for `load` before arming, so the flip
 * cannot compete with the hero image for bandwidth or main thread, and it only
 * arms while the hero is actually on screen.
 */
(function () {
  'use strict';

  var HOLD = 7000;

  var box = document.querySelector('[data-hero-rotator]');
  if (!box) return;

  var slides = box.querySelectorAll('[data-hero-slide]');
  if (slides.length < 2) return;

  /* A still hero on the campaign slide. Someone who asked the OS for less
     motion gets the offer and keeps it; they are not handed a different
     opening message than everyone else, they simply never see the second. */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var idx = 0;
  var left = slides.length - 1;
  var timer = null;
  var io = null;
  var armed = false;

  function halt() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (io) { io.disconnect(); io = null; }
  }

  function step() {
    var next = idx + 1;
    if (next >= slides.length) { halt(); return; }

    slides[idx].className = 'home-hero__slide';
    slides[idx].setAttribute('aria-hidden', 'true');
    slides[next].className = 'home-hero__slide is-on';
    slides[next].removeAttribute('aria-hidden');

    idx = next;
    left = left - 1;
    if (left > 0) { timer = setTimeout(step, HOLD); } else { halt(); }
  }

  function arm() {
    if (armed) return;
    armed = true;
    timer = setTimeout(step, HOLD);
  }

  function start() {
    if (!('IntersectionObserver' in window)) { arm(); return; }
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { arm(); return; }
      }
    }, { threshold: 0.4 });
    io.observe(box);
  }

  if (document.readyState === 'complete') { start(); }
  else { window.addEventListener('load', start); }
}());
